import { apiFetch } from './api';

/**
 * Reporting (menu Reporting) : formations réalisées et historique des
 * demandes, sur une période. Les exports Excel passent par exportService
 * avec les mêmes filtres (chemins ci-dessous).
 */

export const CHEMIN_EXPORT_FORMATIONS = '/reporting/formations/export';
export const CHEMIN_EXPORT_FORMATEURS = '/reporting/formateurs/export';
export const CHEMIN_EXPORT_HISTORIQUE = '/reporting/historique/export';

/** Les paramètres vides ne sont pas transmis : le serveur ne borne pas. */
function versQuery(params) {
  const query = new URLSearchParams();
  for (const [cle, valeur] of Object.entries(params)) {
    if (valeur !== undefined && valeur !== null && valeur !== '') query.set(cle, valeur);
  }
  const s = query.toString();
  return s ? `?${s}` : '';
}

/** Journées planifiées passées sur la période, avec les totaux. */
export function getFormationsRealisees(params = {}) {
  return apiFetch(`/reporting/formations${versQuery(params)}`);
}

/** Répartition par formateur des journées réalisées sur la période. */
export function getRepartitionFormateurs(params = {}) {
  return apiFetch(`/reporting/formateurs${versQuery(params)}`);
}

/** Journal de toutes les demandes sur la période (paginé). */
export function getHistoriqueDemandes(params = {}) {
  return apiFetch(`/reporting/historique${versQuery(params)}`);
}
